module.exports = __webpack_public_path__ + "assets/img/38_376.7899c208.jpg";